var _defs, _circle, _circle2, _line, _rect, _path, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubsciptionUpgrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tick_empty",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .subsciptionupgradeline {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n\n      .subscriptionupgradefill {\n        fill: currentColor;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "subscriptionupgradefill",
    cx: 17.18,
    cy: 8.85,
    r: 1.56
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "subscriptionupgradefill",
    cx: 33.84,
    cy: 8.85,
    r: 1.56
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "subsciptionupgradeline",
    x1: 3.13,
    y1: 12.5,
    x2: 46.86,
    y2: 12.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "subsciptionupgradeline",
    x: 3.13,
    y: 5.21,
    width: 43.73,
    height: 39.57,
    rx: 6.25,
    ry: 6.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "subsciptionupgradeline",
    d: "M21.14,27.09v4.99c0,.36.29.65.65.65h6.4c.36,0,.65-.29.65-.65v-4.98c0-.36.3-.66.66-.66h3.7c.62,0,.93-.76.48-1.19l-8.24-7.89c-.25-.24-.65-.24-.9,0l-8.24,7.89c-.45.43-.14,1.19.48,1.19h3.71c.36,0,.65.29.65.65Z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "subsciptionupgradeline",
    x1: 20.93,
    y1: 36.82,
    x2: 29.06,
    y2: 36.82
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "subsciptionupgradeline",
    x1: 23.37,
    y1: 40.09,
    x2: 26.62,
    y2: 40.09
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubsciptionUpgrade);
export default __webpack_public_path__ + "static/media/subsciption_upgrade.91dc7a2267538ad234353b530bfe5680.svg";
export { ForwardRef as ReactComponent };